// extracted by mini-css-extract-plugin
module.exports = {"container":"Thankyou_container__1h_Dc","description":"Thankyou_description__1YSPD","text":"Thankyou_text__3HVcn","icon":"Thankyou_icon__37AVE"};